import React from 'react';
import PropTypes from 'prop-types';
import SimplePullToRefresh from 'react-simple-pull-to-refresh';
import CircularProgress from '@material-ui/core/CircularProgress';

import { isApp } from 'services/environment';

function PullToRefresh(props) {
  const { children, onRefresh, ...others } = props;

  const handleRefresh = () => {
    const promises = [];
    // Add a minimum time for the refresh so the user feels like something happened.
    promises.push(new Promise(resolve => setTimeout(resolve, 500)));

    if (typeof onRefresh === 'function') {
      promises.push(onRefresh());
    }
    return Promise.all(promises);
  };

  if (!isApp()) {
    return children;
  }

  return (
    <SimplePullToRefresh
      refreshingContent={<CircularProgress style={{ marginTop: 15 }} />}
      pullingContent={null}
      onRefresh={handleRefresh}
      {...others}
    >
      {children}
    </SimplePullToRefresh>
  );
}

PullToRefresh.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node.isRequired)])
    .isRequired,
  onRefresh: PropTypes.func,
};

PullToRefresh.defaultProps = {
  onRefresh: null,
};

export default PullToRefresh;
